/* Package JSON Import will be here */
import { reverse } from "lodash";
/* Package JSON Import will be here */

/* Project Import will be here */
import {
  getNotificationCountApi,
  getNotificationDetailsApi,
  updateNotificationStatusApi
} from "../services/notification";
import { getErrorObject } from "../utilities/utils";
import Constants from "utilities/appConstants";
/* Project Import will be here */

export const types = {
  NOTIFICATION_COUNT_REQUEST: "notification/NOTIFICATION_COUNT_REQUEST",
  NOTIFICATION_COUNT_SUCCESS: "notification/NOTIFICATION_COUNT_SUCCESS",
  NOTIFICATION_COUNT_FAILURE: "notification/NOTIFICATION_COUNT_FAILURE",
  NOTIFICATION_FAILURE: "notification/NOTIFICATION_FAILURE",
  NOTIFICATION_DETAIL_REQUEST: "notification/NOTIFICATION_DETAIL_REQUEST",
  NOTIFICATION_DETAIL_SUCCESS: "notification/NOTIFICATION_DETAIL_SUCCESS",
  NOTIFICATION_STATUS_SUCCESS: "notification/NOTIFICATION_STATUS_SUCCESS",
  NOTIFICATION_UPDATE_SORTING: "notification/NOTIFICATION_UPDATE_SORTING",
  NOTIFICATION_RESET_SORTING: "notification/NOTIFICATION_RESET_SORTING"
};

const initialState = {
  count: 0,
  isLoading: false,
  error: null,
  data: [],
  sortingType: Constants.DATE_ASC
};

export const notifications = (state = initialState, action) => {
  switch (action.type) {
    case types.NOTIFICATION_COUNT_REQUEST:
    case types.NOTIFICATION_COUNT_SUCCESS:
    case types.NOTIFICATION_COUNT_FAILURE:
      return notificationsCountReducer(state, action);
    case types.NOTIFICATION_DETAIL_REQUEST:
    case types.NOTIFICATION_DETAIL_SUCCESS:
      return notificationDetailsReducer(state, action);
    case types.NOTIFICATION_STATUS_SUCCESS:
      return {
        ...state,
        isLoading: false
      };
    case types.NOTIFICATION_UPDATE_SORTING:
      return {
        ...state,
        sortingType: action.payload.sortingType,
        data: action.payload.data
      };
    case types.NOTIFICATION_RESET_SORTING:
      return {
        ...state,
        sortingType: Constants.DATE_ASC
      };
    case types.NOTIFICATION_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload.error,
        count: 0,
        data: []
      };
    default:
      return state;
  }
};

const notificationsCountReducer = (state, action) => {
  switch (action.type) {
    case types.NOTIFICATION_COUNT_REQUEST:
      return { ...state, isLoading: true };
    case types.NOTIFICATION_COUNT_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload.error,
        count: 0
      };
    case types.NOTIFICATION_COUNT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
        count: action.payload.count
      };
    default:
      return state;
  }
};

const notificationDetailsReducer = (state, action) => {
  switch (action.type) {
    case types.NOTIFICATION_DETAIL_REQUEST:
      return { ...state, isLoading: true };
    case types.NOTIFICATION_DETAIL_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
        data: action.payload
      };
    default:
      return state;
  }
};

export const getNotificationCount = () => {
  return async dispatch => {
    dispatch({ type: types.NOTIFICATION_COUNT_REQUEST });
    try {
      const response = await getNotificationCountApi();
      const count = response.data.Count;
      dispatch({
        type: types.NOTIFICATION_COUNT_SUCCESS,
        payload: { count }
      });
    } catch (error) {
      dispatch(promiseCatchBlock(error, types.NOTIFICATION_COUNT_FAILURE));
    }
  };
};

export const getNotificationDetails = (isFirstTime) => {
  return async (dispatch, getState) => {
    dispatch({ type: types.NOTIFICATION_DETAIL_REQUEST });

    /* Reset notification sorting if the page loaded first time */
    if (isFirstTime)
      dispatch({ type: types.NOTIFICATION_RESET_SORTING });

    try {
      const notifications = getState().notifications;

      /* Get notification from API */
      const response = await getNotificationDetailsApi();

      /* Apply sorting based on selected sorting type */
      const payload = notifications.sortingType === Constants.DATE_ASC || isFirstTime ? response.data.Data : reverse(response.data.Data);

      dispatch({ type: types.NOTIFICATION_DETAIL_SUCCESS, payload });
      dispatch({ type: types.NOTIFICATION_COUNT_SUCCESS, payload: { count: payload.length } });
    }
    catch (error) {
      dispatch(promiseCatchBlock(error, types.NOTIFICATION_FAILURE));
    }
  };
};

/* update the notification status as read when the user read the notification */
export const updateNotificationStatus = (notificationId) => {
  return async dispatch => {
    try {
      const data = {
        "Id": notificationId
      };
      await updateNotificationStatusApi(data);
    } catch (error) {
      dispatch(promiseCatchBlock(error, types.NOTIFICATION_FAILURE));
    }
  };
};

export const changeNotificationSorting = () => {
  return (dispatch, getState) => {
    const notifications = getState().notifications;
    if (notifications.data.length > 0) {
      const updatedSortingType = notifications.sortingType === Constants.DATE_ASC ? Constants.DATE_DESC : Constants.DATE_ASC;
      const updatedData = reverse(notifications.data);

      dispatch({
        type: types.NOTIFICATION_UPDATE_SORTING,
        payload: {
          sortingType: updatedSortingType,
          data: updatedData
        }
      });
    }
  };
}

/* Generic code for promise catch block */
const promiseCatchBlock = (error: any, type: string) => {
  return (dispatch) => {
    const { message } = getErrorObject(error);
    dispatch({
      type: type,
      payload: { error: message }
    });
  }
};